<template>
  <section style="background-color: white">
    <div class="container">
      <el-carousel :interval="4000" indicator-position="outside" height="270px">
        <el-carousel-item class="banner">
          <img :src="banner1">
        </el-carousel-item>
        <div class="headerFont">
          <span class="headerFontOne">魅力城轨 &nbsp;  美丽徐州</span><br>
          <span class="headerFontTwo">致力于打造 “最可信赖的公共交通服务者和最具活力的城市发展建设者” 。</span>
        </div>
      </el-carousel>
    </div>
    <el-row>
      <el-col :span="16" :offset="4">
        <section class="filter filterNew">
          <div class="container">   
            <el-form :inline="true" :model="filter" class="filter-form" label-position="top">
              <el-form-item label="公司">
                <el-select v-model="filter.compNo" placeholder="请选择">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="item in compList"
                    :key="item.comp_NO"
                    :label="item.comp_NAME"
                    :value="item.comp_NO" />
                </el-select>
              </el-form-item>
              <el-form-item label="岗位名称">
                <el-input v-model="filter.keyword" placeholder="招聘岗位名称" />
              </el-form-item>
              <el-form-item label="招聘类型">
                <el-select v-model="filter.zplx" placeholder="请选择">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="item in interviewactivityDictList"
                    :key="item.fid"
                    :label="item.fname"
                    :value="item.fnumber" />
                </el-select>
              </el-form-item>
              <el-form-item label="查询" class="hiddenLabel">
                <el-button type="danger" @click="_getRecruitList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </section>
      </el-col>
    </el-row>
    <section class="tabs-result">
      <el-row>
        <el-col :span="16" :offset="4">
          <div class="bar">
            <div @click="show(1)" class="tab" :class="{active:remenShow}" name="first">
              热门岗位
              <icon v-show="remenShow" style="display:block;color: red; margin: 0 auto;font-weight: bolder">_</icon>
            </div>
            <div @click="show(2)" class="tab" :class="{active:zhaopinShow}" name="second">招聘活动
              <icon v-show="zhaopinShow" style="display:block;color: red; margin: 0 auto;font-weight: bolder">_</icon>
            </div>
          </div>
          <div ref="tab-1" class="item" v-for="item in data" :key="item.id" @click="jumpTo(item.id)" v-show="remenShow">
            <img :src="flagNew" class="flag" v-if="checkNew(item.releasedate)">
            <div class="item-top">
              <div class="top-left">
                <div class="icon">●</div>
                <div>
                  <p class="title">{{item.name}}</p>
                  <p class="info">{{item.zplx}}/{{item.education}}</p>
                </div>
              </div>
              <div class="top-right">
                <img :src="coIcon">
                <div class="con">
                  <p>招聘公司及部门</p>
                  <p class="info">{{item.comp_NAME}}-{{item.dept_NAME}}</p>
                </div>
                <img :src="rightClick" class="icon">
              </div>
            </div>
            <div class="item-bottom">
              <div> 发布时间： {{ (item.releasedate + '').slice(0,10) }}</div>
              <div> 招聘人数：{{ item.renum }}</div>
            </div>
          </div>
          <el-pagination
            v-show="remenShow"
            :total="pagination.total"
            :page-size="pagination.listRows"
            :current-page="pagination.page"
            layout="total, prev, pager, next"
            @current-change="changePage" />
          <div class="item" v-show="zhaopinShow">
            暂无信息
          </div>
        </el-col>
      </el-row>
    </section>
    <section class="result container" style="display: none">
      <el-table
        v-loading="loading"
        border
        :data="data"
        style="width: 100%"
        height="500px">
        <el-table-column
          prop="name"
          label="招聘名称"
          width="180" >
          <template slot-scope="scope">
            <router-link :to="'/recruit/' + scope.row.id">{{ scope.row.name }}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="fnumber"
          label="招聘类型">
          <template slot-scope="scope">
            {{ getZPLBName(scope.row.fnumber) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="comp_NAME"
          label="招聘公司"
          width="300" />
        <el-table-column
          prop="dept_NAME"
          label="招聘部门" />
        <el-table-column
          prop="education"
          label="学历要求" />
        <el-table-column
          prop="releasedate"
          label="发布日期" >
          <template slot-scope="scope">
            <template v-if="scope.row.releasedate !== null">
              {{ (scope.row.releasedate + '').slice(0,10) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="JZRQ"
          label="截止日期" >
          <template slot-scope="scope">
            <template v-if="scope.row.JZRQ !== null">
              {{ (scope.row.JZRQ + '').slice(0,10) }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pagination.total"
        :page-size="pagination.listRows"
        :current-page="pagination.page"
        layout="total, prev, pager, next"
        @current-change="changePage" />
    </section>
  </section>
</template>
<script>
import Banner1 from 'assets/PC/banner_rczp.png'
import coIcon from 'assets/PC/zpgsjbm_icon_rczp.png'
import redClick from 'assets/PC/hongjiantou_icon_rczp.png'
import flagNew from 'assets/PC/zuixin_icon_rczp.png'
import { getRecruitList, getFilterOptions, getZplx } from 'api/recruit'
import { parseTime } from 'utils/index'
export default {
  data: () => {
    return {
      remenShow: true,
      zhaopinShow: false,
      parseTime,
      banner1: Banner1,
      coIcon: coIcon,
      rightClick: redClick,
      flagNew: flagNew,
      activeName:'first',
      currentYear:'',
      data: [
      ],
      loading: false,
      filter: {
        keyword: '',
        zplx: '',
        compNo: ''
      },
      interviewactivityDictList: [],
      compList: [],
      pagination: {
        page: 1,
        listRows: 10,
        total: 0
      }
    }
  },
  beforeCreate() {
  },
  created() {
    if (this.$route.params.hasOwnProperty('keyword')) {
      this.filter.keyword = this.$route.params.keyword
    }
    this._getRecruitList()
    this._getFilterOptions()
    this._getZplx()
  },
  methods: {
    show(id) {
      if (id === 1) {
        this.zhaopinShow = false
        this.remenShow = true
      } else {
        this.zhaopinShow = true
        this.remenShow = false
      }
    },
    checkNew(releasedate) {
      const item = new Date(releasedate)
      var date = new Date()
      this.currentYear = date.getFullYear() // 获取完整的年份(4位)
      return (item.getFullYear() === this.currentYear) && (item.getMonth() === date.getMonth())
    },
    jumpTo(id) {
      this.$router.push({path: '/recruit/'+id})
    },
    changePage(page) {
      this.pagination.page = page
      this._getRecruitList()
    },
    _getRecruitList() {
      this.loading = true
      getRecruitList(this.filter, this.pagination.page, 10).then((data) => {
        if (data.code > 0) {
          this.data = data.data[0].data
          this.pagination.total = data.data[0].total
        }
        this.loading = false
      })
    },
    _getFilterOptions() {
      getFilterOptions().then((data) => {
        if (data.code > 0) {
          this.compList = data.data
        }
      })
    },
    _getZplx() {
      getZplx().then((data) => {
        if (data.code > 0) {
          this.interviewactivityDictList = data.data
        }
      })
    },
    getZPLBName(fnumber) {
      for (let i = 0; i < this.interviewactivityDictList.length; i++) {
        if (fnumber === this.interviewactivityDictList[i].fnumber) {
          return this.interviewactivityDictList[i].fname
        }
      }
    }
  }
}
</script>
<style>
.hiddenLabel label{
  color: white;
}
.filter-form{
  text-align: center;
}
.el-form-item{
  text-align: left;
}
.el-input__inner:hover {
  border-color: #db000d;
}

.el-input__inner:focus {
  border-color: #db000d;
}
.el-select:hover .el-input__inner:hover{
  border-color: #db000d;
}
.el-select-dropdown__item.selected{
  color: #db000d;
}
.el-pagination{
  text-align: center;
}
.el-pager li.active{
  color: #db000d;
}
.el-pager li{
  background-color: #ccc;
  margin: 2px;
  border-radius: 3px;
}
.el-pager li.active{
  background-color: #db000d;
  color: white;
}
.el-pager li:hover{
  background-color: #db000d;
  color: white;
}
.el-pagination button:hover{
  color: #db000d;
}
.el-button{
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/recruit/list.vue